/* Seasonal particles for slides and banners: falling maple leaves, rising embers, snow. */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var LEAF = ['%23C2410C', '%23D97706', '%23B45309', '%239A3412', '%23E08A3C'];
  function leaf(c) {
    return "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill='" + c + "' d='M20 2l3.4 7 5-2.4-1.2 8.2 7.6-3.4-2.6 6.6 5.6 1.4-6.4 5.8 1.8 4-8-1.6.6 5-6.2-3-6.2 3 .6-5-8 1.6 1.8-4L1 20.4 6.6 19 4 12.4l7.6 3.4L10.4 7.6l5 2.4z'/%3E%3Cpath d='M20 38V19M20 26l-6-5M20 26l6-5' stroke='%23fff' stroke-opacity='.35' stroke-width='1.2' fill='none'/%3E%3C/svg%3E\")";
  }
  function make(host) {
    var kind = host.getAttribute('data-fx'); if (!kind || host.querySelector(':scope > .fx')) return;
    var layer = document.createElement('div'); layer.className = 'fx fx-' + kind; layer.setAttribute('aria-hidden', 'true');
    var n = innerWidth < 700 ? 9 : 16;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i'), size = 14 + Math.random() * 20;
      p.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      p.style.setProperty('--d', (9 + Math.random() * 9).toFixed(1) + 's');
      p.style.setProperty('--dl', (-Math.random() * 16).toFixed(1) + 's');
      p.style.setProperty('--s', size.toFixed(0) + 'px');
      p.style.setProperty('--sw', ((Math.random() < .5 ? -1 : 1) * (30 + Math.random() * 60)).toFixed(0) + 'px');
      p.style.setProperty('--r', ((Math.random() < .5 ? -1 : 1) * (180 + Math.random() * 360)).toFixed(0) + 'deg');
      if (kind === 'leaves') p.style.backgroundImage = leaf(LEAF[i % LEAF.length]);
      if (kind === 'embers') { p.style.setProperty('--s', (3 + Math.random() * 5).toFixed(0) + 'px'); p.style.setProperty('--d', (6 + Math.random() * 6).toFixed(1) + 's'); }
      if (kind === 'snow') { p.style.setProperty('--s', (4 + Math.random() * 7).toFixed(0) + 'px'); p.style.setProperty('--d', (10 + Math.random() * 10).toFixed(1) + 's'); }
      layer.appendChild(p);
    }
    host.insertBefore(layer, host.firstChild);
    var size = function () { layer.style.setProperty('--h', host.clientHeight + 'px'); };
    size(); addEventListener('resize', size);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { layer.classList.toggle('paused', !es[0].isIntersecting); }, { threshold: 0 }).observe(host);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-fx]'), make); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
